// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__d04Ay","title":"Info_title__3DU6f","links":"Info_links__391CL","link":"Info_link__mEswh","logo":"Info_logo__3ZwHn"};